import { TENANTS_NAMES, HOST } from '../tenant/host_config';
import { i18n as defaulti18n } from './default/index';
import { i18n as xpoi18n } from './xpo/index';
import { i18n as intraseri18n } from './intraser/index';

const i18nByTenant = {
  [TENANTS_NAMES.intraser]: intraseri18n,
  [TENANTS_NAMES.xpo]: xpoi18n,
  [TENANTS_NAMES.ontruck]: defaulti18n,
  [TENANTS_NAMES.acme]: defaulti18n,
};

const geti18nByTenant = (tenant) => {
  return i18nByTenant[tenant] || defaulti18n;
};

const getCurrentTenant18n = () => {
  return geti18nByTenant(HOST);
};

export {
  geti18nByTenant,
  i18nByTenant,
  defaulti18n as i18n,
  getCurrentTenant18n,
};
